/** @format */

export const CONTENT_CATEGORY_ARTICLE_RESULTS_PER_PAGE = 12;
